import { render, staticRenderFns } from "./InvestFormulaSummary.vue?vue&type=template&id=e160c8e2"
import script from "./InvestFormulaSummary.vue?vue&type=script&lang=js"
export * from "./InvestFormulaSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports